import getNewRelicInstance from './getNewRelicInstance';
var SUPPRESSED_ERRORS = ['Initiator ([Video 18]) is not a Screen or a ScreenObject. Analytics would be confused',
// coming from celtra.com
'Intl.PluralRules is not available in this environment. Try polyfilling it using "@formatjs/intl-pluralrules',
// TODO: https://chegg.atlassian.net/browse/BADGER-774 this is a bug with an old version of safari
'message: user have access restrictions', 'r is undefined',
// from https://cdn.gladly.com
'Script error',
// Occurs mostly in Safari happens outside of the app.
"'Document': 'div:has(> iframe[id='198230182308109283091823098102938908128390'])'",
// from unknown 3rd party script
"Can't find variable: _33AcrossIdMappingsProvider", "Can't find variable: tlAdhesion", "Cannot read properties of null (reading 'removeChild')",
// Generated by Branch web sdk too.
"Cannot read properties of null (reading 'vdata", "Cannot read properties of undefined (reading 'image')", "null is not an object (evaluating 'e.parentNode.removeChild')",
// Generated by Branch web sdk when dismissing the modal with a click outside of the modal.
'ResizeObserver loop completed with undelivered notifications.',
// from third party, no trace to know from where exactly
"Unexpected identifier 'Promise'",
// Generated by third-party honey browser extension
"Unexpected token '<'",
// Generated by third-party AdScript/SearchAdScripts
'UET is not defined',
// Ad/tracker blocking.
// In release v1220 (Oct 7, 2022), NewRelic added handlers for unhandledrejection and unhandledPromiseRejection.
// When we upgraded in June 2024, the new error reporting caused a storm. Suppress errors to simulate previous behavior.
'Unhandled Promise Rejection', 'Uncaught TypeError', 'Uncaught RangeError', 'Uncaught SyntaxError', 'Uncaught ReferenceError: tlAdhesion is not defined', "TypeError: null is not an object (evaluating '(this.xdom?t:t.parent).document')", "TypeError: null is not an object (evaluating 'window.top.document')", 'NS_ERROR_NOT_INITIALIZED:', "TypeError: null is not an object (evaluating 'this.topWindow",
// // Ignoring errors related to 'topWindow' when it's not accessible or undefined (e.g., in certain browser environments or iframe contexts).
'Uncaught SecurityError: An attempt was made to break through the security policy of the user agent.', 'Uncaught ReferenceError: setTimeout is not defined', "ReferenceError: Can't find variable: setTimeout", 'TypeError: window.setTimeout is not a function.', "Uncaught SecurityError: Failed to read a named property 'setTimeout' from 'Window': Blocked a restricted frame with origin 'https://www.chegg.com' from accessing another frame.", 'TypeError: window.top is null', 'Uncaught SecurityError: Blocked a restricted frame with origin "https://www.chegg.com" from accessing another frame.', "Uncaught SecurityError: Failed to read a named property 'host' from 'Location': Blocked a restricted frame with origin 'https://www.chegg.com' from accessing another frame.", "Uncaught SecurityError: Failed to read a named property 'performance' from 'Window': Blocked a restricted frame with origin 'https://www.chegg.com' from accessing another frame.", "TypeError: undefined is not an object (evaluating 'this.adapter.resizeAd')", "Can't find variable: gmo"];

// This is the code used by one-graph authorization layer. To rely on standard
// once GraphQL Error Standard is created.
// https://gitlab.com/chegginc/chegg-templates/typescript/libraries/node-framework/-/blob/main/packages/schema-authz/src/types/index.ts#L9
var AUTHORIZATION_ERROR_CODE = 'FORBIDDEN';
var SUPPRESSED_STACK_TRACE = ['chrome-extension://', 'https://cdn.cookielaw.org/opt-out/otCCPAiab.js', 'https://cdn.gladly.com/', 'https://cdn.sprig.com', 'injectCoinbaseWalletDappProvider.js', 'safari-extension://', 'window.gladlyWidgetLoader', 'from accessing another frame' // TODO: https://chegg.atlassian.net/browse/CWF-2658. Multiple Uncaught security errors have identical stack traces and is most likely coming from the same place. https://onenr.io/0ERPrZNZkQW
];

// Check if its an error we want to suppress
var isSuppressedMessage = function isSuppressedMessage(errorMessage) {
  return process.env.CHEGG_ENV === 'prod' &&
  // Compare the error string against the list of expected errors
  SUPPRESSED_ERRORS.some(function (e) {
    return errorMessage.toLowerCase().includes(e.toLowerCase());
  });
};

// Check if its an error we want to suppress
var isSuppressedStackTrace = function isSuppressedStackTrace(errorStackTrace) {
  return (
    // Compare the error stack trace against the list of expected errors that contain that stacktrace
    SUPPRESSED_STACK_TRACE.some(function (e) {
      return errorStackTrace.toLowerCase().includes(e.toLowerCase());
    })
  );
};
var isSuppressedCode = function isSuppressedCode(errorCode) {
  return errorCode === AUTHORIZATION_ERROR_CODE;
};
/**
 * We don't know what types "error" from setErrorHandler actually can be, so, cover a number of bases here
 */
var canonicalizeError = function canonicalizeError(error) {
  var _error$extensions;
  if (typeof error === 'string') return {
    message: error.trim(),
    code: '',
    stack: ''
  };

  // If our `error` has any of the expected properties assume we have the neccessary information to proceed
  // covers cases where `error instanceof Error` and `error.constructor.name === 'UnhandledException'` among other potentially unknown cases
  if ('message' in error || 'extensions' in error || 'stack' in error) return {
    message: "".concat(error.message || '').trim(),
    // some utilities we make use of extend the Error object with code
    code: "".concat(((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.code) || '').trim(),
    stack: "".concat(error.stack || '').trim()
  };

  // we set everything to an empty string and filter it out later
  return {
    message: '',
    code: '',
    stack: ''
  };
};
var valueIsFalsey = function valueIsFalsey(value) {
  return !value;
};
var isCanonicalErrorEmpty = function isCanonicalErrorEmpty(error) {
  return Object.values(error).every(valueIsFalsey);
};
var isOddlyStructured = function isOddlyStructured(error) {
  if (error.code && !error.message) return {
    group: "CheggWeb(UnknownError): Empty error 'message' detected with 'code' present."
  };
  if (error.stack && !error.message) return {
    group: "CheggWeb(UnknownError): Empty error 'message' detected with 'stack' present."
  };
  return false;
};

// method typing based on https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/seterrorhandler/#examples
export var errorHandler = function errorHandler(error) {
  // if we somehow have a falsey error (unclear if this is possible in real world conditions) ignore it
  if (!error) return true;
  var canonicalizedError = canonicalizeError(error);
  return (
    // suppress errors which do not have useful error messages at all
    isCanonicalErrorEmpty(canonicalizedError) ||
    // suppress errors whose code matches against list of expected client error code
    isSuppressedCode(canonicalizedError.code) ||
    // suppress errors whose message matches against list of expected errors
    isSuppressedMessage(canonicalizedError.message) ||
    // suppress errors whose stack matches against expected stack traces
    isSuppressedStackTrace(canonicalizedError.stack) ||
    // group cases where the canonical error has an odd looking structure
    isOddlyStructured(canonicalizedError) ||
    // let New Relic capture the error
    false
  );
};

// Called from app.tsx, will check if we should ignore the error
var setNewRelicErrorHandler = function setNewRelicErrorHandler() {
  // Run on the client only
  if (typeof window !== 'undefined' && Boolean(window.newrelic)) {
    var nrInstance = getNewRelicInstance();

    /**
     * On `as newrelic.ErrorHandler`
     *
     * the types for newrelic.ErrorHandler are wrong, even for the latest version of
     *  its types package, so, we force setErrorHandler to accept our errorHandler via type coersion
     */
    nrInstance.setErrorHandler(errorHandler);
  }
};
export default setNewRelicErrorHandler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/observability/dist/esm/NewRelicHelpers/setNewRelicErrorHandler.js
// module id = 2624
// module chunks = 11